// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Us5L","buttons":"PendingPaymentAlert_buttons__3o7Rj"};